export default __webpack_public_path__ + "static/hero-817690f342dabb7a28566ff0de273f27.png";